export const overlay = (isOverlayToggled) => {
  const $body = $("body");
  const $overlay = $(".js-overlay");
  const btnToggleOverlay = ".js-toggle-overlay";

  let index = 1;

  let overlayState = isOverlayToggled;

  const init = () => {
    bind();
  };

  const bind = () => {
    $body.on("click", btnToggleOverlay, e => {
      e.preventDefault();
      toggleOverlay();
    });

    $(".js-overlay li a").on("mouseenter", function (event) {
      $(".js-overlay li a").addClass("is-faded");
      $(this).removeClass("is-faded");
    });
    $(".js-overlay li a").on("mouseleave", function (event) {
      $(".js-overlay li a").removeClass("is-faded");
    }); 
      
  };

  const toggleOverlay = () => {
    if (overlayState) {
      $body.attr("data-overlay-open", "false");
    } else {
      $body.attr("data-overlay-open", "true");
    }
    overlayState = !overlayState;
  };

  init();

};
